import React from 'react'
import { getCommunityModeratorEnabledCached } from '../services/communityModeratorService'

export function useCommunityModeratorEnabled(userId: string | null, active = true) {
  const [enabled, setEnabled] = React.useState<boolean | null>(null)

  React.useEffect(() => {
    if (!active) {
      setEnabled(false)
      return
    }

    const id = String(userId || '').trim()
    if (!id) {
      setEnabled(false)
      return
    }

    let mounted = true
    ;(async () => {
      try {
        const ok = await getCommunityModeratorEnabledCached(id)
        if (!mounted) return
        setEnabled(ok)
      } catch {
        if (!mounted) return
        setEnabled(false)
      }
    })()

    return () => {
      mounted = false
    }
  }, [active, userId])

  return enabled
}

